module.exports = __webpack_public_path__ + "media/KikiMI.d0ff2918.mp3";